import $ from "jquery";
import { application } from "../application/application";
import { dataaccess } from "../dataaccess/dataContext";
import { forms } from "../framework/forms";

function init() {
    addEvents();
    if ($("#modifyEthosBankSite").length > 0) {
        renderLmsTab();
    }
}

function addEvents() {
    $(document).on("click", "#btnLoadMergeSite", btnLoadMergeSiteClick);
    $(document).on("click", "#btnMergeSiteProfileCancel", btnMergeSiteProfileCancelClick);
    $(document).on("click", "#btnMergeSiteSaveMerge", btnMergeSiteSaveMergeClick);
    $(document).on("click", "#deactivate-site-dropdown a", deactivateSite);
    $(document).on("click", "#activate-site-dropdown a", activateSite);
    $(document).on("click", ".js-btn-adminEthosBank-Site", jsBtnAdminEthosBankSiteClick);
    $(document).on("click", "#btnUpdateEthosBankSite", btnUpdateEthosBankSiteClick);
}

function activateSite() {
    const programSiteId = $(this).attr("programSiteId");
    const params = {
        url: "/sitedetails/activate/" + programSiteId,
        successMsg: "Successfully activated",
        showSpinner: "True"
    };
    dataaccess
        .post(params)
        .fail(function (result) {
            alert("Error activating site");
            showMessage("Error activating site");
        })
        .done(function (result) {
            window.location.href = application.baseUrl + "/sitedetails/index/" + $("#siteId").val();
        });
}

function deactivateSite() {
    const programSiteId = $(this).attr("programSiteId");
    const params = {
        url: "/sitedetails/deactivate/" + programSiteId,
        successMsg: "Successfully deactivated",
        showSpinner: "True"
    };
    dataaccess
        .post(params)
        .fail(function (result) {
            alert("Error deactivating site");
            showMessage("Error deactivating site");
        })
        .done(function (result) {
            window.location.href = application.baseUrl + "/sitedetails/index/" + $("#siteId").val();
        });
}

function btnLoadMergeSiteClick() {
    const fromSiteId = $("#fromSiteId").val();
    const loadSiteId = $("#siteMergeToId").val();
    if (loadSiteId === fromSiteId) {
        showMessage("You cannot merge into the same site");
        return;
    }
    const params = { url: "/sitedetails/getmergeintosite/" + loadSiteId, showSpinner: "True" };
    dataaccess.get(params).done(function (result) {
        $("#divMergeSiteDetails").html(result);
        if ($("#mergeIntoId").val() < 1) {
            showMessage("Site was not found");
        } else {
            hideMessage();
            $("#btnMergeSiteSaveMerge").show();
        }
    });
}

function btnMergeSiteProfileCancelClick() {
    $("#mergeSiteButton").removeClass("hidden");
    $("#btnMergeSiteSaveMerge").addClass("hidden");
}

function btnMergeSiteSaveMergeClick() {
    const fromSiteId = $("#fromSiteId").val();
    const intoSiteId = $("#mergeIntoId").val();
    if (intoSiteId < 1) {
        showMessage("Need a site to merge into");
        return;
    }
    const params = {
        data: {
            fromSiteId: fromSiteId,
            intoSiteId: intoSiteId
        },
        url: "/sitedetails/mergesite",
        successMsg: "Successfully merged sites",
        showSpinner: "True"
    };
    dataaccess
        .post(params)
        .fail(function (result) {
            alert("Error merging sites");
            showMessage("Error merging sites");
        })
        .done(function (result) {
            window.location.href = application.baseUrl + "/sitedetails/index/" + intoSiteId;
        });
}

function showMessage(message) {
    $("#siteMergeToIdMessage").html(message);
    $("#siteMergeToIdMessage").removeClass("hidden");
}

function hideMessage() {
    $("#siteMergeToIdMessage").addClass("hidden");
}

function jsBtnAdminEthosBankSiteClick() {
    const $tr = $(this).closest("tr");
    const siteId = $tr.attr("data-siteId");
    const siteName = $tr.attr("data-siteName").replace("/", "%2F");
    const programId = $tr.attr("data-programId");
    const programName = $tr.attr("data-programName");
    const courseEditionId = $tr.attr("data-courseEditionId");
    const courseEditionName = $tr.attr("data-courseEditionName");
    dataaccess
        .get({
            url: "/EthosBankSite/Site/" + siteId + "/" + encodeURI(siteName) + "/Program/" + programId + "/" + programName + "/CourseEdition/" + courseEditionId + "/" + courseEditionName
        })
        .done(function (result) {
            $("#modifyEthosBankSite")
                .find(".modal-content")
                .html(result);
            $("#modifyEthosBankSite").modal("show");
        });
}

function btnUpdateEthosBankSiteClick(e) {
    e.preventDefault();
    const $form = $(this).closest("form");

    if ($form.valid()) {
        forms.showSpinner("Updating...");
        const params = {
            contentType: dataaccess.contentType.APPLICATION_X_WWW_FORM_URLENCODED,
            data: $form.serialize(),
            url: $form.attr("action"),
            successMsg: "Successfully adjusted licenses."
        };

        dataaccess.post(params).done(function () {
            $("#modifyEthosBankSite").modal("hide");
            renderLmsTab();
            forms.hideSpinner();
        });
    }
}

function renderLmsTab() {
    const siteId = $("#siteId").val();
    const params = { url: "/SiteDetails/LMSPasses/Site/" + siteId };
    dataaccess.get(params).done(function (result) { $("#siteEthosPassesContainer").html(result) });

}

export const siteDetails = { 
    init: init
};
